import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  ListItem,
  List,
} from "@chakra-ui/react";

export default function HowWeReview() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          How We Review
        </Heading>
        <Stack spacing={4} fontSize="md">
          <Text>
            We evaluate providers using consistent, documented criteria:
          </Text>
          <List.Root as="ul" pl={6} spacing={2}>
            <List.Item>Pricing transparency & fees</List.Item>
            <List.Item>Case experience & scope of services</List.Item>
            <List.Item>Customer outcomes & satisfaction signals</List.Item>
            <List.Item>Compliance, certifications, and disclosures</List.Item>
          </List.Root>
          <Text fontSize="sm" opacity={0.8}>
            Last updated: {new Date().toLocaleDateString()}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
